// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"853":"625ab704","925":"80ef645d","967":"74b3b8f1"}[chunkId] + ".chunk.js");